module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_styled_03-16d896bc768703d01cb1f447157800ce.png";